import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManagementStraPageComponent } from './components/management-stra-page/management-stra-page.component';
import { AdminManagementStraComponent } from './components/admin-management-stra/admin-management-stra.component';
import { AdminGuard } from 'src/app/services/admin.guard';

const routes: Routes = [  
  {
    path: ':name', component: ManagementStraPageComponent, data: { title: '' }
  },
  {
    path: '',canActivate:[AdminGuard], component: AdminManagementStraComponent, data: { title: '' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagementStratgeyRoutingModule { }
